import styled from 'styled-components'

import { helpers } from 'styles'

export const Page = styled.div`
	align-items: center;
	background-color: ${helpers.color.white};
	display: flex;
	flex-direction: column;
	margin-top: -24px;
	min-height: calc(100vh - 78px);
	padding: 50px 32px 48px;
	text-align: center;

	> h1 {
		font-size: 40px;
		line-height: 48px;
		margin: 0;
	}

	> p {
		font-size: 16px;
		line-height: 22px;
		margin: 22px auto 0;
		max-width: 596px;
	}

	> form {
		align-items: center;
		display: flex;
		flex-direction: column;
		margin-top: 64px;
		width: 100%;
	}

	> a {
		color: ${helpers.color.text};
		font-size: 16px;
		line-height: 22px;
		margin-top: 40px;
		text-decoration: underline;
	}

	@media only screen and (max-width: 800px) {
		padding: 40px 16px;

		> h1 {
			font-size: 32px;
			line-height: 40px;
		}

		> form {
			margin-top: 40px;
		}

	}
`
